export enum TransactionStatusEnum {
  SCAN_QR_CODE = 'scan_qr_code',
  DEBITED = "debited",
  AWAITING_SETTLEMENT = "awaiting_settlement",
  COMPLETED = "completed",
  FAILED = "failed",
  CANCELLED = "canceled",
  ALLOW_RETRY_SETTLEMENT = "allow_retry_settlement"
}

